<phms-terminology-concept-catalog *ngIf="workspaceMode() === 'catalog' && showConceptCatalog()"
    [restoredState]="conceptCatalogState" (viewStateChange)="conceptCatalogState = $event"
    (editDefinition)="editCurrentPackDefinition($event)" (createDefinition)="createCurrentPackDefinition()">
</phms-terminology-concept-catalog>
<main [class.catalog-open]="showEditorCatalog()" class="terminology-catalog terminology-catalog--editing" data-testid="terminology-catalog" *ngIf="workspaceMode() === 'catalog' && !showConceptCatalog()">
    <header class="catalog-titlebar">
        <div>
            <h1>Terminology</h1>
            <span class="workstation-status">Current pack · Save updates active wording</span>
        </div>
        <div class="titlebar-actions">
            <button type="button" class="button button--secondary" (click)="browseConceptCatalog()" [disabled]="editorNavigationBusy()">Back to Concepts</button>
            <button type="button" class="button button--secondary" (click)="showEditorCatalog.set(!showEditorCatalog())" [disabled]="editorNavigationBusy()" [attr.aria-expanded]="showEditorCatalog()" aria-controls="terminology-editor-catalog">Browse definitions</button>
        </div>
    </header>

    <section class="contextual-entry" data-testid="terminology-contextual-entry"
        *ngIf="contextualSource() as source" aria-label="Contextual terminology entry">
        <div class="contextual-entry__origin">
            <span>Opened from application</span>
            <strong>{{ contextualSourceLabel() }}</strong>
            <small>{{ contextualSnapshotLabel() }}</small>
        </div>
        <dl class="contextual-entry__evidence">
            <div>
                <dt>Source scope</dt>
                <dd>{{ contextualSourceScopeLabel() }}</dd>
            </div>
            <div>
                <dt>Catalog revision</dt>
                <dd>{{ contextualLoadedWordingLabel() }}</dd>
            </div>
            <div>
                <dt>Change reach</dt>
                <dd>{{ contextualInfluenceLabel() }}</dd>
            </div>
        </dl>
        <button type="button" class="button button--secondary contextual-entry__return"
            data-testid="terminology-return-to-source"
            *ngIf="source.returnUrl" (click)="returnToContextualSource()">
            Return to source
        </button>
    </section>

    <div class="message-box error catalog-message" *ngIf="vocabularyCatalogError() as error" role="alert" aria-live="assertive">
        <p>{{ error.title }}</p>
        <span *ngFor="let message of error.messages">{{ message }}</span>
    </div>
    <div class="message-box success catalog-message" *ngIf="vocabularyCatalogSuccess() as message" role="status" aria-live="polite">
        <p>{{ message }}</p>
    </div>

    <form *ngIf="showEditorCatalog()" class="catalog-toolbar" role="search" (ngSubmit)="applyCatalogFilters()">
        <label class="search-field">
            <span class="visually-hidden">Search terminology</span>
            <span class="search-icon" aria-hidden="true">⌕</span>
            <input type="search" name="terminologySearch" [(ngModel)]="catalogSearch"
                placeholder="Search wording, token, feature, or route" autocomplete="off">
        </label>

        <label>
            <span>Kind</span>
            <select name="terminologyKind" [(ngModel)]="catalogKindCode">
                <option value="">All kinds</option>
                <option *ngFor="let kindCode of vocabularyCatalog()?.availableKindCodes" [value]="kindCode">
                    {{ toDisplayLabel(kindCode) }}
                </option>
            </select>
        </label>

        <label>
            <span>Status</span>
            <select name="terminologyStatus" [(ngModel)]="catalogStatusCode">
                <option value="">All statuses</option>
                <option value="published">Published</option>
                <option value="unpublished">Unpublished</option>
                <option value="inactive">Inactive</option>
            </select>
        </label>

        <label>
            <span>Usage</span>
            <select name="terminologyUsage" [(ngModel)]="catalogUsageStateCode">
                <option value="">All usage</option>
                <option value="used">Observed references</option>
                <option value="unobserved">No observed references</option>
            </select>
        </label>

        <button type="submit" class="button button--primary toolbar-submit">Apply</button>
        <button type="button" class="button-link" (click)="clearCatalogFilters()"
            [disabled]="!catalogSearch && !catalogKindCode && !catalogStatusCode && !catalogUsageStateCode">Clear</button>
    </form>

    <div class="catalog-workspace">
        <section id="terminology-editor-catalog" class="catalog-list-pane" aria-labelledby="terminology-catalog-heading">
            <div class="pane-heading">
                <div>
                    <h2 id="terminology-catalog-heading">Vocabulary catalog</h2>
                    <span>{{ catalogResultRange() }}</span>
                </div>
                <span class="release-label" *ngIf="vocabularyCatalog() as catalog">Release {{ catalog.releaseIdentifier }}</span>
                <button type="button" class="button button--secondary catalog-refresh" (click)="refreshVocabularyCatalog()"
                    [disabled]="isVocabularyCatalogLoading() || isDefinitionDetailLoading() || editorNavigationBusy()">Refresh</button>
            </div>

            <div class="catalog-columns" aria-hidden="true">
                <span>Wording</span><span>Token</span><span>Kind</span><span>Status</span><span>Usages</span>
            </div>

            <div class="catalog-loading" *ngIf="isVocabularyCatalogLoading()" role="status" aria-live="polite">
                Loading vocabulary catalog…
            </div>

            <div class="catalog-list" role="group" aria-label="Terminology definitions" *ngIf="!isVocabularyCatalogLoading()">
                <button type="button" class="catalog-row" *ngFor="let item of vocabularyCatalog()?.items"
                    [class.catalog-row--selected]="!isCreatingVocabularyDefinition() && selectedDefinitionId() === item.definitionId"
                    [attr.aria-pressed]="!isCreatingVocabularyDefinition() && selectedDefinitionId() === item.definitionId"
                    (click)="selectVocabularyDefinition(item)">
                    <span class="wording-cell" [title]="item.currentText">{{ item.currentText }}</span>
                    <code class="token-cell" [title]="item.tokenCode">{{ item.tokenCode }}</code>
                    <span>{{ toDisplayLabel(item.kindCode) }}</span>
                    <span class="status-cell">
                        <span class="status-badge" [ngClass]="vocabularyStatusClass(item.lifecycleStatusCode)">
                            {{ toDisplayLabel(item.lifecycleStatusCode) }}
                        </span>
                    </span>
                    <span class="usage-cell">{{ item.deployedUsageCount }}</span>
                </button>

                <div class="catalog-empty" *ngIf="vocabularyCatalog()?.items?.length === 0">
                    No definitions match the current filters.
                </div>
            </div>

            <footer class="catalog-pagination" *ngIf="catalogTotalPages() > 1">
                <button type="button" (click)="goToCatalogPage(catalogPage - 1)" [disabled]="catalogPage === 1">Previous</button>
                <span>Page {{ catalogPage }} of {{ catalogTotalPages() }}</span>
                <button type="button" (click)="goToCatalogPage(catalogPage + 1)" [disabled]="catalogPage === catalogTotalPages()">Next</button>
            </footer>
        </section>

        <aside class="definition-inspector" aria-labelledby="definition-inspector-heading">
            <div class="inspector-loading" *ngIf="isDefinitionDetailLoading()" role="status" aria-live="polite">
                Loading definition details…
            </div>

            <form class="definition-create" data-testid="terminology-definition-create"
                *ngIf="isCreatingVocabularyDefinition()" (ngSubmit)="saveNewVocabularyDefinition()">
                <header class="definition-create__header">
                    <div class="inspector-kicker">
                        <span>Definition</span>
                        <span class="status-badge status-badge--draft">New</span>
                    </div>
                    <h2 id="definition-inspector-heading">New phrase</h2>
                    <p>Add a standalone phrase to the currently loaded program pack. It becomes active as soon as it is saved.</p>
                </header>

                <div class="definition-create__fields">
                    <label>
                        <span>Token</span>
                        <input type="text" name="newDefinitionTokenCode" [(ngModel)]="newDefinitionTokenCode" (ngModelChange)="creationFieldChanged('newDefinitionTokenCode')"
                            [disabled]="isCreatingVocabularyDefinitionSaving()"
                            [attr.aria-invalid]="newDefinitionFieldErrors()['newDefinitionTokenCode'] ? 'true' : null"
                            [attr.aria-describedby]="newDefinitionFieldErrors()['newDefinitionTokenCode'] ? 'new-definition-token-error' : null"
                            maxlength="160" autocomplete="off" spellcheck="false"
                            placeholder="feature.surface.label" required>
                        <small>A stable lowercase identifier used by application features.</small>
                        <small class="field-error" id="new-definition-token-error" *ngIf="newDefinitionFieldErrors()['newDefinitionTokenCode'] as error">{{ error }}</small>
                    </label>

                    <label>
                        <span>Initial wording</span>
                        <textarea name="newDefinitionContentText" [(ngModel)]="newDefinitionContentText" (ngModelChange)="creationFieldChanged('newDefinitionContentText')"
                            [disabled]="isCreatingVocabularyDefinitionSaving()"
                            [attr.aria-invalid]="newDefinitionFieldErrors()['newDefinitionContentText'] ? 'true' : null"
                            [attr.aria-describedby]="newDefinitionFieldErrors()['newDefinitionContentText'] ? 'new-definition-content-error' : null"
                            maxlength="2000" rows="3" required></textarea>
                        <small>{{ newDefinitionContentText.length }} / 2,000 characters</small>
                        <small class="field-error" id="new-definition-content-error" *ngIf="newDefinitionFieldErrors()['newDefinitionContentText'] as error">{{ error }}</small>
                    </label>

                    <label>
                        <span>Description <em>Optional</em></span>
                        <textarea name="newDefinitionDescription" [(ngModel)]="newDefinitionDescription" (ngModelChange)="creationFieldChanged('newDefinitionDescription')"
                            [disabled]="isCreatingVocabularyDefinitionSaving()"
                            [attr.aria-invalid]="newDefinitionFieldErrors()['newDefinitionDescription'] ? 'true' : null"
                            [attr.aria-describedby]="newDefinitionFieldErrors()['newDefinitionDescription'] ? 'new-definition-description-error' : null"
                            maxlength="1000" rows="3"
                            placeholder="Where this wording is intended to be used"></textarea>
                        <small>Internal guidance for other terminology authors.</small>
                        <small class="field-error" id="new-definition-description-error" *ngIf="newDefinitionFieldErrors()['newDefinitionDescription'] as error">{{ error }}</small>
                    </label>
                </div>

                <footer class="definition-create__actions">
                    <button type="submit" class="button button--primary"
                        [disabled]="isCreatingVocabularyDefinitionSaving()">
                        {{ isCreatingVocabularyDefinitionSaving() ? 'Creating…' : 'Create phrase' }}
                    </button>
                    <button type="button" class="button button--secondary"
                        (click)="cancelCreateVocabularyDefinition()"
                        [disabled]="isCreatingVocabularyDefinitionSaving()">Cancel</button>
                    <span>Creates an active phrase in the current program pack.</span>
                </footer>
            </form>

            <ng-container *ngIf="!isCreatingVocabularyDefinition()">
            <ng-container *ngIf="selectedDefinitionDetail() as detail; else noDefinitionSelected">
                <div class="inspector-scroll" [class.inspector-scroll--loading]="isDefinitionDetailLoading()">
                    <header class="inspector-header inspector-header--compact" data-testid="terminology-definition-inspector">
                        <div class="inspector-kicker">
                            <span>Definition</span>
                            <span class="status-badge" [ngClass]="vocabularyStatusClass(detail.definition.lifecycleStatusCode)">
                                {{ toDisplayLabel(detail.definition.lifecycleStatusCode) }}
                            </span>
                        </div>
                        <h2 id="definition-inspector-heading">{{ detail.definition.currentText }}</h2>
                        <details class="inspector-identity"><summary>Identity</summary><div class="token-line">
                            <code>{{ detail.definition.tokenCode }}</code>
                            <button type="button" class="icon-button" (click)="copySelectedToken()"
                                [attr.aria-label]="tokenCopied() ? 'Token copied' : 'Copy token'"
                                [title]="tokenCopied() ? 'Copied' : 'Copy token'">{{ tokenCopied() ? '✓' : '⧉' }}</button>
                        </div></details>
                        <div class="inspector-context">
                            <span>Program pack: {{ detail.definition.versionCode || detail.definition.initialWording?.versionCode || 'Unavailable' }}</span>
                            <span>{{ toDisplayLabel(detail.definition.grammaticalFormCode || detail.definition.kindCode) }}</span>
                            <span>{{ vocabularyScope(detail.definition) }}</span>
                        </div>
                    </header>

                    <phms-platform-terminology-vocabulary-editor
                        [detail]="detail"
                        [canAuthor]="canAuthor()"
                        [detailLoading]="isDefinitionDetailLoading()"
                        [editorContextKey]="editorContextKey()"
                        [usageManifest]="usageManifest()"
                        [selectedUsageId]="selectedUsageId()"
                        [initialView]="selectedVocabularyView()"
                        (definitionSelected)="openVocabularyEditorDefinition($event, true)"
                        (editingStateChange)="onEditorEditingStateChange($event)"
                        (accessLost)="onTerminologyAccessLost()"
                        (contextReloadRequested)="reloadVocabularyEditorDefinition($event)"
                        (wordingSaved)="onVocabularyWordingSaved($event)">
                    </phms-platform-terminology-vocabulary-editor>
                </div>
            </ng-container>

            <ng-template #noDefinitionSelected>
                <div class="inspector-empty" id="definition-inspector-heading">
                    Select a definition to inspect and edit its wording, family, usages, and release state.
                </div>
            </ng-template>
            </ng-container>
        </aside>
    </div>
</main>

<ng-container *ngIf="workspaceMode() === 'legacy-editor'">
    <div class="legacy-editor-return">
        <button type="button" class="button-link" (click)="returnToVocabularyCatalog()">← Back to vocabulary catalog</button>
        <span>Legacy entry editor — retained temporarily for records that have not moved to the vocabulary catalog.</span>
    </div>
    <ui-section>
        <ui-block>
            <ui-panel width="fill" class="platform-terminology-admin" panelTitle="Platform Terminology" title="Platform Terminology"
                [subtitle]="pagePanelSubtitle" [panelHeaderConfig]="pagePanelHeaderConfig" (buttonClick)="onPagePanelHeaderButtonClick($event)">
                <div class="message-box success" *ngIf="successMessage()" role="status" aria-live="polite">{{ successMessage() }}</div>

                <div class="message-box error" *ngIf="errorState() as error" role="alert" aria-live="assertive">
                    <p>{{ error.title }}</p>
                    <ul><li *ngFor="let message of error.messages">{{ message }}</li></ul>
                    <div class="error-meta" *ngIf="error.problemCode || error.issueCodes.length > 0 || error.correlationId">
                        <span *ngIf="error.problemCode">Problem code: {{ error.problemCode }}</span>
                        <span *ngIf="error.issueCodes.length > 0">Issue codes: {{ error.issueCodes.join(', ') }}</span>
                        <span *ngIf="error.correlationId">Correlation ID: {{ error.correlationId }}</span>
                    </div>
                </div>

                <ui-section>
                    <ui-block width="4x">
                        <ui-grid width="3x" class="catalog-panel" [dsConfig]="catalogGridConfig" [panelHeaderConfig]="catalogPanelHeaderConfig"
                            [showPanelHeader]="true" [reloadOnChangeTrigger]="catalogReloadTrigger()"></ui-grid>
                    </ui-block>

                    <ui-panel width="fill" [panelTitle]="isCreatingEntry() ? 'Create Terminology Entry' : (selectedEntry()?.tokenCode || 'Terminology Entry Detail')"
                        [title]="isCreatingEntry() ? 'Create Terminology Entry' : (selectedEntry()?.tokenCode || 'Terminology Entry Detail')">
                        <div class="detail-panel__body" aria-label="Terminology detail">
                            <div class="detail-panel__header">
                                <p>{{ isCreatingEntry() ? 'Create an entry for the selected configuration version.' : (selectedEntry()?.configurationCode + ' / ' + selectedEntry()?.versionCode || 'Select an entry from the catalog.') }}</p>
                                <div class="detail-panel__status" *ngIf="selectedEntry() as entry">
                                    <span class="status-pill">{{ selectedEntryStatusLabel() }}</span><span>Locale: {{ entry.localeCode }}</span>
                                </div>
                            </div>

                            <p class="loading-text" *ngIf="isEntryLoading()" role="status" aria-live="polite">Loading the selected terminology entry...</p>
                            <ng-container *ngIf="!isEntryLoading()">
                                <div class="inline-note" *ngIf="editBlockedReason()">{{ editBlockedReason() }}</div>
                                <ui-form #terminologyForm [config]="terminologyFormConfig" [(formValues)]="formValues"
                                    [disabled]="isSaving() || !!editBlockedReason()" [showFormErrors]="true"></ui-form>
                                <ui-button-group class="form-actions" [buttonsConfig]="entryFormActionButtons()"
                                    (buttonClick)="onEntryFormActionButtonClick($event)"></ui-button-group>

                                <section class="usage-panel" *ngIf="selectedEntry() as entry" aria-labelledby="legacy-terminology-usage-heading">
                                    <div class="usage-panel__header">
                                        <div><h3 id="legacy-terminology-usage-heading">Where this wording appears</h3><p>Declared direct usages for <code>{{ entry.tokenCode }}</code>.</p></div>
                                        <span class="usage-count" *ngIf="usageManifest() && !isUsageManifestLoading()">{{ selectedEntryUsages().length }} usages</span>
                                    </div>
                                    <p class="loading-text" *ngIf="isUsageManifestLoading()">Loading deployed usage evidence...</p>
                                    <div class="inline-note usage-panel__error" *ngIf="usageManifestError()">{{ usageManifestError() }}</div>
                                    <div class="usage-list" *ngIf="selectedEntryUsages().length > 0">
                                        <article class="usage-card" *ngFor="let usage of selectedEntryUsages()">
                                            <div class="usage-card__heading"><div><h4>{{ toDisplayLabel(usage.surfaceCode) }}</h4><p>{{ usage.componentCode }}</p></div><span class="source-pill">{{ toDisplayLabel(usage.sourceSide) }}</span></div>
                                            <div class="usage-card__locations"><span *ngFor="let location of usage.locations">{{ toDisplayLabel(location.kind) }}: <code>{{ location.value }}</code></span></div>
                                        </article>
                                    </div>
                                </section>
                            </ng-container>
                        </div>
                    </ui-panel>
                </ui-section>
            </ui-panel>
        </ui-block>
    </ui-section>
</ng-container>
